import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  createContext,
  useContext,
} from "react";
import { toast } from "react-toastify";
import { buildColumns } from "../utils/helper";
import useList from "../controller/list-controller";
import { debounce } from "debounce";
import { ConstListContext } from "./constListContext";

export const AccountListContext = createContext();

export const AccountListContextProvider = ({ children }) => {
  const prevStateRef = useRef();
  const constContData = useContext(ConstListContext);
  const { constData } = constContData;
  const { getListViewRecords, tableData, isLoading, errMsg } = useList();
  const [isLoader, setIsLoader] = useState(true);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currPage, setCurrPage] = useState(0);
  const [totalRec, setTotalRec] = useState(0);
  const [flag, setFlag] = useState(true);
  const [sort, setSort] = useState("");
  const [orderCol, setOrderCol] = useState("");
  const [orderType, setOrderType] = useState("");
  const [searchContext, setSearchContext] = useState("");

  useEffect(() => {
    setFlag(false);
    setSearchContext("");
  }, []);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  useEffect(() => {
    if (constData?.["Account"]?.length > 0) {
      const actFil = constData?.["Account"]?.find((dt) => dt?.isDefault);
      setSort(actFil?.listViewId);
    }
  }, [constData]);

  useEffect(() => {
    const header = buildColumns(tableData?.fields);
    setIsLoader(tableData?.records ? false : true);
    setColumns(header);
    setData(tableData?.records);

    (tableData?.totalRecordCount || tableData?.totalRecordCount === 0) &&
      setTotalRec(
        Math.ceil(
          tableData?.totalRecordCount
            ? parseInt(tableData?.totalRecordCount) / tableData?.recordCount
            : 1
        )
      );
    (tableData?.pageNo || tableData?.pageNo === 0) &&
      setCurrPage(tableData?.pageNo - 1);
  }, [tableData]);

  useEffect(() => {
    prevStateRef.current !== sort && setSearchContext("");
    if (sort) {
      if (orderCol || orderType) {
        setOrderCol("");
        setOrderType("");
      }
      if (!flag) getList(searchContext, sort);
    }
    prevStateRef.current = sort;
  }, [sort]);

  useEffect(() => {
    if (orderCol || orderType) {
      setOrderCol("");
      setOrderType("");
    }
    if (!flag) getSearchDebounce(searchContext, sort);
  }, [searchContext]);

  const getList = (searchData = searchContext) => {
    getListViewRecords({
      objectName: "Account",
      listViewId: sort,
      pageNo: 1,
      orderByField: "",
      orderByAPIField: "",
      orderDirection: "",
      searchKey: searchData,
    });
  };

  const getSearchDebounce = useCallback(
    debounce((searchData, sortData) => {
      getListViewRecords({
        objectName: "Account",
        listViewId: sortData,
        pageNo: 1,
        orderByField: "",
        orderByAPIField: "",
        orderDirection: "",
        searchKey: searchData,
      });
    }, 500),
    []
  );

  const handleGetAccounts = (page = 0, field = "", apiField = "", dir = "") => {
    page = page + 1;
    getListViewRecords({
      objectName: "Account",
      listViewId: sort,
      pageNo: page,
      orderByField: field,
      orderByAPIField: apiField,
      orderDirection: dir,
      searchKey: searchContext,
    });
  };

  return (
    <AccountListContext.Provider
      value={{
        isLoader,
        columns,
        data,
        currPage,
        totalRec,
        orderCol,
        setOrderCol,
        orderType,
        setOrderType,
        setSearchContext,
        handleGetAccounts,
      }}
    >
      {children}
    </AccountListContext.Provider>
  );
};
